import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M11.257 10.703 2 7a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2l-9.257 3.703a2 2 0 0 1-1.486 0"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M2 17V9l9.257 3.703a2 2 0 0 0 1.486 0L22 9v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2"
    }
  )
);
var SvgEmailFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var EmailFilled_default = SvgEmailFilled;

export { EmailFilled_default as default };
